module.exports = __webpack_public_path__ + "assets-cabinet/img/bell-icon.6bf77699.svg";